import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import {State} from "../../ducks"
import {REALM_HEADER} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const {
        settings: {saleName, threeFourImageryEnabled},
        template,
        request: {headers},
        shoppingBag: {showMiniBagItemDescription: showItemDescription, showMiniBagProductName: showProductName},
    } = state
    const realm = (headers as IncomingHttpHeaders)[REALM_HEADER] as string
    return {
        saleName,
        templating: template,
        realm,
        showItemDescription,
        showProductName,
        threeFourImageryEnabled,
    }
}

export default connect(mapStateToProps)
